import { TEST_CONFIG } from 'js/ab_tests/tests/autotest_login_modal_2026_q3_v1';

import type { LoginModalEventDetail } from '../LoginModalManager';
import { LoginModalAutotestHooks, PartialConfigurableText } from '../types';

// Buckets derive from the generated test module so the registry can never
// drift from the yml: an arm name that isn't in the yml fails to typecheck.
export type Bucket = (typeof TEST_CONFIG.alternatives)[number];
export type Arm = Exclude<Bucket, 'control'>;

export type OpenContext = {
  detail: LoginModalEventDetail;
};

export type ArmSpec = {
  slots?: (ctx: OpenContext) => LoginModalAutotestHooks['slots'];
  configuredTextOverride?: (
    ctx: OpenContext,
  ) => PartialConfigurableText | undefined;
  wrapOnSuccess?: LoginModalAutotestHooks['wrapOnSuccess'];
  onClose?: (ctx: OpenContext) => void;
  ctaDefaultExpanded?: (ctx: OpenContext) => boolean;
  pageInit?: () => void;
};

// Empty until the arm PRs land: every arm resolves through the full dispatch
// path (membership recording, impression, tracking stamps) and renders
// control pixel-for-pixel. An arm with no entry yields no hooks at all.
export const ARMS: Partial<Record<Arm, ArmSpec>> = {};
